(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        "use strict";
        var __webpack_exports__ = {};
        __webpack_require__.r(__webpack_exports__);
    }();
    !function() {
        (() => {
            if (window.erk_best_seller) {
                return;
            }
            window.erk_best_seller = true;
            const SELECT = "erk-best-seller__select";
            const TRIGGER = "erk-best-seller__select-trigger";
            const LIST = "erk-best-seller__select-list";
            const OPTION = "erk-best-seller__select-option";
            const CARD = "erk-best-seller__card";
            const ATC_FORM = "erk-best-seller__atc-form";
            const applyVariant = (card, option) => {
                if (!card || !option) return;
                const id = option.getAttribute("data-variant-id");
                const idInput = card.querySelector(`.${ATC_FORM} input[name="id"]`);
                if (idInput && id) idInput.value = id;
                const priceNow = card.querySelector(".erk-best-seller__price-now");
                const price = option.getAttribute("data-price");
                if (priceNow && price) priceNow.innerHTML = price;
                const priceWas = card.querySelector(".erk-best-seller__price-was");
                if (priceWas) {
                    const compare = option.getAttribute("data-compare");
                    if (option.getAttribute("data-on-sale") === "true" && compare) {
                        priceWas.innerHTML = compare;
                        priceWas.hidden = false;
                    } else {
                        priceWas.hidden = true;
                    }
                }
                const priceSave = card.querySelector("[data-erk-price-save]");
                if (priceSave) {
                    const save = option.getAttribute("data-save");
                    if (save) {
                        priceSave.innerHTML = "Save " + save;
                        priceSave.hidden = false;
                    } else {
                        priceSave.hidden = true;
                    }
                }
                const baseUrl = card.getAttribute("data-product-url");
                if (baseUrl && id) {
                    const href = `${baseUrl}${baseUrl.indexOf("?") === -1 ? "?" : "&"}variant=${id}`;
                    card.querySelectorAll("a.erk-best-seller__btn--outline, a.erk-best-seller__btn--solid").forEach((a => {
                        a.setAttribute("href", href);
                    }));
                }
                const trigger = card.querySelector(`.${TRIGGER}`);
                if (trigger) {
                    const tLabel = trigger.querySelector(".erk-best-seller__select-label");
                    const oLabel = option.querySelector(".erk-best-seller__select-label");
                    if (tLabel && oLabel) tLabel.textContent = oLabel.textContent;
                    const tThumb = trigger.querySelector("[data-erk-select-thumb]");
                    const oThumb = option.querySelector(".erk-best-seller__select-thumb");
                    if (tThumb) {
                        tThumb.innerHTML = oThumb ? oThumb.innerHTML : "";
                    }
                }
            };
            const swapImage = (card, imageUrl, imageMobileUrl) => {
                if (!imageUrl) return;
                const media = card.querySelector(".erk-best-seller__media");
                if (!media) return;
                const img = media.querySelector("img");
                if (!img) return;
                let source = media.querySelector("picture source");
                if (imageMobileUrl) {
                    if (!source) {
                        const picture = document.createElement("picture");
                        source = document.createElement("source");
                        source.setAttribute("media", "(max-width: 768px)");
                        picture.appendChild(source);
                        img.parentNode.insertBefore(picture, img);
                        picture.appendChild(img);
                    }
                    source.setAttribute("srcset", imageMobileUrl);
                } else if (source) {
                    source.remove();
                }
                img.setAttribute("srcset", imageUrl);
                img.src = imageUrl;
            };
            const getOptions = sel => Array.from(sel.querySelectorAll(`.${OPTION}`));
            const selectOption = (sel, option) => {
                if (!option || option.classList.contains("is-unavailable")) return;
                getOptions(sel).forEach((o => {
                    const on = o === option;
                    o.classList.toggle("is-selected", on);
                    o.setAttribute("aria-selected", on ? "true" : "false");
                }));
                const card = sel.closest(`.${CARD}`);
                applyVariant(card, option);
                swapImage(card, option.getAttribute("data-image"), option.getAttribute("data-image-mobile"));
            };
            const open = sel => {
                const trigger = sel.querySelector(`.${TRIGGER}`);
                const list = sel.querySelector(`.${LIST}`);
                if (!trigger || !list) return;
                trigger.setAttribute("aria-expanded", "true");
                list.hidden = false;
                sel.classList.add("is-open");
                const current = sel.querySelector(`.${OPTION}.is-selected`) || getOptions(sel)[0];
                if (current) {
                    current.tabIndex = 0;
                    current.focus();
                }
            };
            const close = (sel, focusTrigger) => {
                const trigger = sel.querySelector(`.${TRIGGER}`);
                const list = sel.querySelector(`.${LIST}`);
                if (!trigger || !list) return;
                trigger.setAttribute("aria-expanded", "false");
                list.hidden = true;
                sel.classList.remove("is-open");
                getOptions(sel).forEach((o => {
                    o.tabIndex = -1;
                }));
                if (focusTrigger) trigger.focus();
            };
            const closeAll = root => {
                root.querySelectorAll(`.${SELECT}.is-open`).forEach((sel => {
                    close(sel, false);
                }));
            };
            const moveFocus = (sel, current, dir) => {
                const opts = getOptions(sel).filter((o => !o.classList.contains("is-unavailable")));
                if (!opts.length) return;
                let idx = opts.indexOf(current);
                if (idx < 0) idx = dir > 0 ? -1 : 0;
                idx = (idx + dir + opts.length) % opts.length;
                opts.forEach((o => {
                    o.tabIndex = -1;
                }));
                opts[idx].tabIndex = 0;
                opts[idx].focus();
            };
            const initRoot = root => {
                if (!root || root.dataset.erkSelectInit) return;
                root.dataset.erkSelectInit = "1";
                root.querySelectorAll(`.${SELECT}`).forEach((sel => {
                    const selected = sel.querySelector(`.${OPTION}.is-selected`);
                    if (selected) applyVariant(sel.closest(`.${CARD}`), selected);
                }));
                root.addEventListener("click", (e => {
                    const trigger = e.target.closest(`.${TRIGGER}`);
                    if (trigger && root.contains(trigger)) {
                        const sel = trigger.closest(`.${SELECT}`);
                        const openFlag = trigger.getAttribute("aria-expanded") === "true";
                        closeAll(root);
                        if (!openFlag) open(sel);
                        return;
                    }
                    const option = e.target.closest(`.${OPTION}`);
                    if (option && root.contains(option)) {
                        if (option.classList.contains("is-unavailable")) return;
                        const optSel = option.closest(`.${SELECT}`);
                        selectOption(optSel, option);
                        close(optSel, true);
                        return;
                    }
                    closeAll(root);
                }));
                root.addEventListener("keydown", (e => {
                    const sel = e.target.closest(`.${SELECT}`);
                    if (!sel) return;
                    const isOpen = sel.classList.contains("is-open");
                    const option = e.target.closest(`.${OPTION}`);
                    if (e.key === "ArrowDown") {
                        e.preventDefault();
                        if (!isOpen) open(sel); else moveFocus(sel, option, 1);
                    } else if (e.key === "ArrowUp") {
                        e.preventDefault();
                        if (!isOpen) open(sel); else moveFocus(sel, option, -1);
                    } else if ((e.key === "Enter" || e.key === " ") && isOpen && option) {
                        e.preventDefault();
                        selectOption(sel, option);
                        close(sel, true);
                    } else if (e.key === "Escape" && isOpen) {
                        e.preventDefault();
                        close(sel, true);
                    } else if (e.key === "Tab" && isOpen) {
                        close(sel, false);
                    }
                }));
            };
            const initCountdown = el => {
                if (!el || el.dataset.erkCountdownInit) return;
                el.dataset.erkCountdownInit = "1";
                const startStr = el.getAttribute("data-erk-countdown-start");
                const endStr = el.getAttribute("data-erk-countdown-end");
                const daysEl = el.querySelector("[data-erk-cd-days]");
                const hoursEl = el.querySelector("[data-erk-cd-hours]");
                const minutesEl = el.querySelector("[data-erk-cd-minutes]");
                const secondsEl = el.querySelector("[data-erk-cd-seconds]");
                const pad = n => String(n).padStart(2, "0");
                const startMs = startStr ? new Date(startStr).getTime() : NaN;
                const endMs = endStr ? new Date(endStr).getTime() : NaN;
                let timer = null;
                const render = val => {
                    const diff = Math.max(0, Math.floor(val / 1e3));
                    if (daysEl) daysEl.textContent = pad(Math.floor(diff / 86400));
                    if (hoursEl) hoursEl.textContent = pad(Math.floor(diff % 86400 / 3600));
                    if (minutesEl) minutesEl.textContent = pad(Math.floor(diff % 3600 / 60));
                    if (secondsEl) secondsEl.textContent = pad(diff % 60);
                };
                const tick = () => {
                    const now = Date.now();
                    if (Number.isFinite(startMs) && now < startMs) {
                        render(startMs - now);
                        return;
                    }
                    if (Number.isFinite(endMs)) {
                        const remaining = endMs - now;
                        if (remaining <= 0) {
                            render(0);
                            if (timer) {
                                clearInterval(timer);
                                timer = null;
                            }
                            return;
                        }
                        render(remaining);
                        return;
                    }
                    render(0);
                    if (timer) {
                        clearInterval(timer);
                        timer = null;
                    }
                };
                tick();
                timer = setInterval(tick, 1e3);
            };
            const initAll = () => {
                const roots = document.querySelectorAll(".erk-best-seller");
                roots.forEach((root => {
                    initRoot(root);
                }));
                document.querySelectorAll("[data-erk-countdown]").forEach((el => {
                    initCountdown(el);
                }));
                document.addEventListener("click", (e => {
                    roots.forEach((root => {
                        if (!root.contains(e.target)) closeAll(root);
                    }));
                }));
            };
            if (document.readyState !== "loading") {
                initAll();
            } else {
                document.addEventListener("DOMContentLoaded", initAll);
            }
        })();
    }();
})();